module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['dof-slider'],
    style: _vm.disabledStyle,
    on: {
      "touchstart": _vm.onTouchStart,
      "horizontalpan": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('div', {
    key: _vm._isColmo + 'slider',
    ref: "track",
    staticClass: ["dof-slider-track"],
    style: _vm.trackStyle
  }, [(_vm.isGradientBar) ? _c('div', {
    staticClass: ["dof-slider-thin-bar"],
    style: _vm.thinBarStyle
  }, [(_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: ["dof-slider-thin-bar-left"],
    style: {
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.start) + ", " + (_vm._gradientBarConfig.mid) + ")"),
      width: _vm.midWidth + _vm._buttonSize / 2 + 1 + 'px'
    }
  }) : _vm._e(), (_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: ["dof-slider-thin-bar-right"],
    style: {
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.mid) + ", " + (_vm._gradientBarConfig.end) + ")"),
      width: _vm.midWidth + _vm._buttonSize / 2 - 1 + 'px'
    }
  }) : _vm._e(), (!_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: ["dof-slider-thin-bar-left"],
    style: {
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.start) + ", " + (_vm._gradientBarConfig.end) + ")"),
      right: 1 + 'px'
    }
  }) : _vm._e()]) : _vm._e(), (!_vm.isGradientBar) ? _c('div', {
    style: _vm.lineStyle
  }) : _vm._e(), _c('div', {
    ref: "bar",
    class: ['dof-slider-bar'],
    style: _vm.barStyle
  }, [(!_vm.isGradientBar) ? _c('div', {
    class: [_vm.barColor || _vm.isGradientBar ? '' : ("dof-slider-bar--" + (this.theme))],
    style: _vm.smallBarStyle
  }) : _vm._e(), _vm._l((_vm.buttonStyle), function(itemStyle, i) {
    return _c('div', {
      key: i + _vm.disabled,
      class: ['dof-slider-button', _vm.isGradientBar ? 'button-scale' : '', _vm._isColmo && _vm.disabled ? 'hideButton' : ''],
      style: itemStyle
    })
  })], 2)]), (_vm.$slots.default) ? _c('div', {
    staticClass: ["dof-slider-scales"]
  }, [_vm._t("default")], 2) : _vm._e(), (_vm.isGradientBar && _vm.disabled) ? _c('div', {
    staticClass: ["dof-slider-disabled-mask"],
    on: {
      "touchstart": _vm.maskTouchStart
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-6a86068c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-slider/index.vue
// module id = 626
// module chunks = 0 1